<template>
  <div class="failureAccess">
    <i class="iconfont icon-shibai-icon topicon"></i>
    <p class="title">{{ tip }}</p>
    <div class="sepLineShell">
      <p class="sepLine"></p>
    </div>
    <div class="orderInfo">
      <div class="shell">
        <p class="list">
          <span class="fl">评估结果</span><span class="fr "><span
              class="seeDetail"
              @click="seeReason"
            >查看详情<i :class="{
                  'iconfont icon-shang': this.seeResult === false,
                  'iconfont icon-xia': this.seeResult === true,
                }"></i></span></span>
        </p>
      </div>
      <p
        class="reason"
        v-if="this.seeResult === true"
      >
        {{ this.$store.state.commonForms.modalErrorReason }}
      </p>
      <div class="shell">
        <p class="list">
          <span class="fl">企业名称</span><span class="fr ">{{ this.$store.state.commonForms.corpName }}</span>
        </p>
        <p class="list">
          <span class="fl">借款人</span><span class="fr ">{{
            this.$store.state.commonForms.borrowerName
          }}</span>
        </p>
        <p class="list">
          <span class="fl">申请产品</span><span class="fr ">{{
            this.$store.state.commonForms.productName
          }}</span>
        </p>
        <p class="list">
          <span class="fl">申请时间</span><span class="fr ">{{
            this.$store.state.commonForms.orderTime
          }}</span>
        </p>
      </div>
    </div>
    <div class="buttonShell" v-if="isShowButton">
      <van-button
        :text="back"
        :type="danger"
        :plain="plain"
        class="goBack"
        @click="gotoHome"
        size="large"
      />
      <van-button
        :text="retry"
        :type="danger"
        class="retry"
        @click="gotoPerfect"
        :disabled="!this.$store.state.commonForms.canRetry"
        size="large"
      />
    </div>
    <server-bank :productId="this.$route.query.productId"></server-bank>
  </div>
</template>

<script>
import API from '@/request/api';
import ServerBank from '@/components/ServerBank.vue';
import { checkStatus } from './mixin';

export default {
  name: 'CreditFailure.vue',
  components: {
    ServerBank,
  },
  data() {
    return {
      isLoading: false,
      retry: '重新申请',
      back: '回到首页',
      danger: 'danger',
      plain: 'plain',
      tip: '预授信失败',
      statusCode: '',
      seeResult: false,
      isShowButton: false,
    };
  },
  mixins: [checkStatus],
  beforeCreate() {
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#fff');
  },
  mounted() {
    this.$store.dispatch('commonForms/checkCurrentStatus', true);
    this.getOrderType();
  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style');
  },
  

  methods: {
    seeReason() {
      this.seeResult = !this.seeResult;
    },
    gotoPerfect() {
      this.$store.dispatch('commonForms/resetOrder');
    },
    gotoHome() {
      window.location.href = '/supermarket/v2/';
    },
    getOrderType() {
      const orderId = localStorage.getItem('orderId') || this.$route.query.orderId;
      API.PublicPage.getOrderType({
        orderId,
        productId: this.$route.query.productId,
      }).then((res) => {
        if (!(res.success && res.data && res.data.orderType === '1')) {
          this.isShowButton = true;
        }
      });
    },
  },
};
</script>
<style scoped>
.reason {
  box-sizing: border-box;
  width: 100%;
  margin-top: 0;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 15px;
  color: #7c7c7c;
  font-size: 12px;
  text-align: left;
  background: #f8f9fb;
}
.title {
  color: #1c2438;
  font-size: 17px;
  letter-spacing: 0;
  text-align: center;
}

.sepLineShell {
  box-sizing: border-box;
  width: 100%;
  margin-top: 40px;
  padding-right: 15px;
  padding-left: 15px;
}
.sepLine {
  width: 100%;
  height: 1px;
  background: #dfdede;
}
.buttonShell {
  box-sizing: border-box;
  width: 100%;
  height: 44px;
  padding-right: 15px;
  padding-left: 15px;
}
.retry {
  float: right;
  width: 46%;
}
.goBack {
  float: left;
  width: 46%;
}
.grey {
  background-color: grey;
}
.shell {
  box-sizing: border-box;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}
.list {
  height: 44px;
  margin: 0;
  padding: 0;
  color: #495060;
  font-size: 14px;
  line-height: 44px;
  letter-spacing: 0;
}
.fl {
  float: left;
  line-height: 22px;
}
.fr {
  float: right;
  width: 70%;
  line-height: 22px;
  text-align: right;
}
.topicon {
  display: block;
  padding-top: 103px;
  color: #ff6538;
  font-size: 60px;
}
.seeDetail {
  color: #f55646;
}
</style>
